import React from 'react'

import clsx from 'clsx'

import classes from './DialogTitle.module.scss'

/** @type {import("./types").default} */
const DialogTitle = ({ children, className }) => {
  return <div className={clsx('DialogTitle', classes.root, className)}>{children}</div>
}

export default DialogTitle
